var Menu = Chaplin.Model.extend({

});

module.exports = Menu;
